import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Avatar } from '@heroui/react'
import { CustomModal, CustomPopover } from '../shared';
import { DotsIcon, GroupChatIcon } from '../../assets/icons';
import GroupMembersModal from './GroupMembersModal';

const ChatAreaHeader = ({
    chatAvatar,
    chatType,
    chatHeaderName,
    chatMembers,
    activeChat,
    setActiveChat,
    deleteChat,
    userId,
    fetchAllChats,
    setOpenContractModal
}) => {
    const [openPopover, setOpenPopover] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openGroupMembersModal, setOpenGroupMembersModal] = useState(false);
    const navigate = useNavigate();

    const handleAvatarClick = () => {
        if (chatType === 'group') return;

        let targetId = null;
        if (!activeChat.channel_id) {
            // It's a user object (e.g. from search selection before message sent)
            targetId = activeChat.id;
        } else if (activeChat.members && activeChat.members.length > 0) {
            // Use first member, same assumption as SideBarBody
            const member = activeChat.members[0];
            targetId = member.user_id || member.id;
        }

        if (targetId) {
            navigate(`/partners/partner-detail/${targetId}`);
        }
    };

    return (
        <React.Fragment>
            <div className='h-[70px] p-4 border-b flex items-center justify-between'>
                <div className="w-[calc(100%-40px)] flex items-center gap-3 pr-2">
                    {activeChat && (
                        <button aria-label="Back to chats" className="hover:bg-surface-hover rounded-full base:hidden" onClick={() => setActiveChat(null)}>
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                    )}
                    {chatType === 'group' ?
                        <div className='w-10 h-10 min-w-10 rounded-full bg-mediumgrey/30 flex items-center justify-center'>
                            <GroupChatIcon className='w-6 h-6' />
                        </div> :
                        <button type="button" className='w-10 h-10 cursor-pointer rounded-full' onClick={handleAvatarClick} aria-label={`View ${chatHeaderName || 'connection'} profile`}>
                            <Avatar
                                src={chatAvatar}
                                classNames={{
                                    base: "bg-mediumgrey/30",
                                    icon: "text-black/60",
                                }}
                            />
                        </button>}
                    <div className='flex flex-col w-[calc(100%-80px)]'>
                        {chatType === 'group' ? (
                            <button
                                className="text-left group cursor-pointer"
                                onClick={() => setOpenGroupMembersModal(true)}
                            >
                                <span className="font-medium truncate group-hover:text-secondary-dark transition-colors">
                                    {chatHeaderName}
                                </span>
                                <p className="text-xs text-mediumgrey group-hover:text-secondary/70 transition-colors">
                                    {chatMembers?.length || activeChat?.members?.length || 0} members · Tap to view
                                </p>
                            </button>
                        ) : (
                            <span className="font-medium truncate">{chatHeaderName}</span>
                        )}
                    </div>
                </div>
                <CustomPopover
                    open={openPopover}
                    setOpen={() => setOpenPopover(!openPopover)}
                    trigger={
                        <div className="ml-auto  text-mediumgrey">
                            <span className="sr-only">Chat options</span>
                            <DotsIcon />
                        </div>
                    }
                    placement='bottom-end'
                >
                    <div className="bg-white border border-surface-border shadow-2xl rounded-md font-sans text-sm flex flex-col">
                        {chatType === 'group' ? (
                            <button type="button" className="vertical-center gap-2 cursor-pointer py-2 px-2 hover:bg-surface-hover text-left"
                                onClick={() => { setOpenGroupMembersModal(true); setOpenPopover(false) }}>
                                <p>View Members</p>
                            </button>
                        ) : null}

                        <button type="button" className="vertical-center gap-2 cursor-pointer py-2 px-2 hover:bg-surface-hover text-left"
                            onClick={() => { setOpenContractModal(true); setOpenPopover(false) }}>
                            <p>Create Contract</p>
                        </button>

                        <button type="button" className="vertical-center gap-2 cursor-pointer py-2 px-2 hover:bg-surface-hover text-left"
                            onClick={() => { setOpenDeleteModal(true); setOpenPopover(false) }}>
                            <p>Delete Chat</p>
                        </button>
                    </div>
                </CustomPopover>
            </div>
            <CustomModal
                title={"Delete Chat"}
                open={openDeleteModal}
                close={() => setOpenDeleteModal(false)}
                showPrimaryButton={true}
                showSecondaryButton={true}
                primaryButtonColor='danger'
                primaryButtonText={'Delete Chat'}
                primaryButtonClick={() => { deleteChat(activeChat?.channel_id); setOpenDeleteModal(false) }}

                secondaryButtonText={'Cancel'}
                secondaryButtonClick={() => setOpenDeleteModal(false)}
            >
                <div className="">
                    <div className="flex flex-col gap-2">
                        <p className="font-sans text-xl">Are you sure you want to delete this chat?</p>
                    </div>
                </div>
            </CustomModal>
            <GroupMembersModal
                open={openGroupMembersModal}
                onClose={() => setOpenGroupMembersModal(false)}
                channelId={activeChat?.channel_id}
                channelName={activeChat?.channel_name}
                isAdmin={activeChat?.is_user_grp_admin}
                currentUserId={userId}
                onMembersUpdated={() => {
                    fetchAllChats && fetchAllChats();
                }}
            />
        </React.Fragment>
    )
}

export default ChatAreaHeader
